/* eslint-disable jsdoc/valid-types */
import { getFeatureConfigForBrand } from 'lib/getFeatureStatus';
import brandFeatures from 'lib/brandFeatures';

export const USA = 'US';
export const AUTHENTICATED = 'authenticated';
export const UNAUTHENTICATED = 'unauthenticated';
export const INITIALIZED = 'initialized';
export const UNINITIALIZED = 'uninitialized';
export const UNKNOWN = 'unknown';
export const GEOLOCATION_COOKIE = 'ng_geolocation';
export const NEWS = 'news';
export const NBCNEWS = 'nbcnews';
export const ALL = 'all';
export const ARTICLE = 'article';
export const VIDEO = 'video';
export const RECIPE = 'recipe';
export const PRODUCT = 'product';
export const AMOUNT_TO_SHOW = 10;
export const AMOUNT_TO_LOAD = 5;
export const RECOMMENDATIONS_AMOUNT = 30;

export const CONTENT_TYPES_TO_ROUTES = {
  article: 'articles',
  video: 'videos',
  recipe: 'recipes',
  product: 'wishlist',
  all: '',
};

/**
 * Inverts keys and values in an object
 * @template {object} T
 * @template {keyof T} K
 * @param {T} obj
 * @returns {{[K in keyof T as T[K]]: K}}
 */
function swapKeysAndValues(obj) {
  return Object.fromEntries(Object.entries(obj).map(([k, v]) => [v, k]));
}

export const ROUTES_TO_CONTENT_TYPES = swapKeysAndValues(CONTENT_TYPES_TO_ROUTES);

export const CONTENT_TYPE_ANCHORS = {
  article: '/articles',
  video: '/videos',
  recipe: '/recipes',
  product: '/wishlist',
};

/**
 * Returns the path to the saved content for a given content type.
 * @param {keyof typeof CONTENT_TYPE_ANCHORS} contentType - The type of content (e.g. 'article', 'video', 'recipe', 'product').
 * @returns {string} The path to the saved content for the given content type.
 */
export const getSavedPath = (contentType) => {
  const accountSavedPath = '/account/saved';
  return `${accountSavedPath}${CONTENT_TYPE_ANCHORS[contentType] || ''}`;
};
/**
 * Retrieves the number of bookmarks to display for a given vertical.
 * If no vertical override exists, falls back to the default --> 20.
 * @param {string | { vertical: string }} vertical – e.g. 'news' | 'today'
 * @param {object} featureFlags – Optional feature flags to consider when determining the number of bookmarks to display
 * @returns {number}
 */
export function getBookmarksDisplayAmount(vertical = '', featureFlags = {}) {
  const brandKey = (typeof vertical === 'string'
    ? vertical
    : vertical?.vertical ?? '')
    .trim()
    .toLowerCase();

  const rawValue = getFeatureConfigForBrand(
    brandFeatures.BOOKMARKS_TO_DISPLAY,
    brandKey,
    featureFlags,
  );

  const numeric = Number(rawValue);
  const fallback = Number(brandFeatures.BOOKMARKS_TO_DISPLAY.default);

  return Number.isFinite(numeric) ? numeric : fallback;
}
